import { useEffect, useState } from 'react';
import { useDarkMode } from '../context/DarkModeContext';
import { FaGhost } from 'react-icons/fa';

const FloatingGhosts = () => {
  const { darkMode } = useDarkMode();
  const [ghosts, setGhosts] = useState([]);

  useEffect(() => {
    if (!darkMode) {
      setGhosts([]);
      return;
    }

    // Create 3-5 random ghosts when dark mode is enabled
    const createGhosts = () => {
      const numberOfGhosts = Math.floor(Math.random() * 3) + 3; // 3-5 ghosts
      const newGhosts = [];

      for (let i = 0; i < numberOfGhosts; i++) {
        newGhosts.push({
          id: i,
          left: Math.random() * 90 + 5, // 5-95% from left
          duration: Math.random() * 10 + 15, // 15-25 seconds
          delay: Math.random() * 5, // 0-5 second delay
          size: Math.random() * 20 + 30, // 30-50px
          opacity: Math.random() * 0.3 + 0.2, // 0.2-0.5 opacity
        });
      }

      setGhosts(newGhosts);
    };

    createGhosts();

    // Recreate ghosts every 30 seconds for variety
    const interval = setInterval(createGhosts, 30000);

    return () => clearInterval(interval);
  }, [darkMode]);

  if (!darkMode || ghosts.length === 0) return null;

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-50">
      {ghosts.map((ghost) => (
        <div
          key={ghost.id}
          className="absolute animate-float-up"
          style={{
            left: `${ghost.left}%`,
            bottom: '-100px',
            animationDuration: `${ghost.duration}s`,
            animationDelay: `${ghost.delay}s`,
            fontSize: `${ghost.size}px`,
            opacity: ghost.opacity,
          }}
        >
          <FaGhost className="text-purple-300 drop-shadow-glow animate-wiggle" />
        </div>
      ))}
    </div>
  );
};

export default FloatingGhosts;
